import { Badge } from '@sea-snag/ui';

import { KIND_BADGE_CLASSES, KIND_LABELS } from '../lib/boat-kinds';

export function BoatTypeBadge({ kind }: { kind: string }) {
  return (
    <Badge variant="outline" className={KIND_BADGE_CLASSES[kind]}>
      {KIND_LABELS[kind] ?? kind}
    </Badge>
  );
}
